/** Converts any value to its string representation; returns '' for null/undefined. */
export const toStringId = value => (value == null ? '' : value.toString());

/**
 * Parses a YYYY-MM-DD string into a local-timezone Date object.
 * Avoids UTC-shift bugs that arise from `new Date('YYYY-MM-DD')`.
 */
export const formatDate = dateString => {
	if (!dateString) return null;
	const [year, month, day] = dateString.split('-');
	return new Date(Number(year), Number(month) - 1, Number(day));
};

/** Returns the email of the currently authenticated user from localStorage. */
export const getCurrentUser = () => {
	try {
		const authUser = JSON.parse(localStorage.getItem('authUser'));
		return authUser?.user?.email || authUser?.email || 'system';
	} catch {
		return 'system';
	}
};

/**
 * Converts Date objects in form values to YYYY-MM-DD strings using local timezone.
 * Returns a plain object safe for JSON serialization in localStorage.
 */
export const serializeFormValues = values => {
	const d = values.breach_date;
	return {
		...values,
		breach_date: d instanceof Date
			? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
			: d ?? null,
	};
};
